export default __webpack_public_path__ + "img/rank4-ce41677c.png";